module.exports = __webpack_public_path__ + "static/media/thankyou-ic.a2a1ece5.svg";